import { lazyLoad } from 'utils/loadable';

export const PlacementDetailsWrapperLoadable = lazyLoad(
  () => import('./PlacementDetailsWrapper'),
  module => module.PlacementDetailsWrapper,
);
